import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface UpdateBigQueryByFiltersPayload {
  filters: Record<string, string>;
  update_data: Record<string, string>;
  request_id?: string;
}

/**
 * POSTs a bulk BigQuery update filtered by column values (e.g. `poc`), without row identifiers.
 * Used for reassignment flows that update all matching rows.
 *
 * @param payload - Column `filters` and `update_data` fields to write
 * @returns Parsed JSON body from the API
 * @throws {Error} When auth is missing, HTTP status is not OK, or the body reports `success: false`
 */
export const updateBigQueryDataByFilters = async (
  payload: UpdateBigQueryByFiltersPayload,
) => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.UPDATE_BIGQUERY_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data && typeof data.success === "boolean" && !data.success) {
      throw new Error(data.message || "BigQuery update was not successful");
    }
    return data;
  } catch (error) {
    console.error("Error updating BigQuery data by filters:", error);
    throw error;
  }
};
